import Environment from '@cobliteam/react-environments';
import { OramaClient } from '@oramacloud/client';
import { useCallback, useEffect, useState } from 'react';
import sidebarDef from '../sidebarDef';
import { type ArticleWithCategory, EnumCategory } from '../types';

const env = Environment.getInstance().getEnvironment();

const oramaClient = new OramaClient({
  endpoint: env.oramaSuporteHost,
  api_key: env.oramaSuporteApiKey,
});

export type Nullable<T> = T | null;

const useFetchArticles = ({ search, limit }: { search: string; limit?: number }) => {
  const [results, setResults] = useState<ArticleWithCategory[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchOrama = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await oramaClient.search({
        term: search,
        limit: limit || undefined,
        mode: 'fulltext',
      });

      if (!results) return;

      const groupCategory = sidebarDef.find((category) => category.categories.find((c) => c.id === EnumCategory.ARTICLES));
      const category = groupCategory?.categories.find((c) => c.id === EnumCategory.ARTICLES);

      const oramaResults =
        response?.hits.map((result) => {
          return { ...result.document, category, categoryOrama: result.document.category };
        }) || [];

      setResults(oramaResults);
    } catch (error) {
      console.error('Error fetching articles:', error);
    } finally {
      setIsLoading(false);
    }
  }, [search, limit]);

  useEffect(() => {
    fetchOrama();
  }, [fetchOrama]); // Change dependency to actual changing values

  return { results, isLoading };
};

export default useFetchArticles;
